<script>
import {mapActions} from "vuex";

export default {
  name: "PaymentCallbacks",
  components: {},
  mixins: [],
  data () {
    return {
      enableLoader: true,
    }
  },
  computed: {},
  watch: {},
  created() {
    const token = this.$route.params.token;
    if (token) {
      this.update({charge_id: token}).then((result) => {
        this.fetchCartCount();
        if (result.code) {
          if (result.ex_code === 'attempted') {
            this.$router.replace({ name: "PaymentAttempts", params: { token: token, code: result.code } });
          } else {
            this.$router.replace({ name: "PaymentFailures", params: { token: token, code: result.code } });
          }

        } else {
          this.$router.replace({ name: "PaymentCompletes", params: { token: token } });
        }
      })
    }
  },
  methods: {
    ...mapActions("frontOrderConfirm", {
      update: "update"
    }),
    ...mapActions('frontCart', {
      fetchCartCount: 'fetchCount'
    }),

  },
}
</script>

<template>
  <v-container>
    <v-overlay
      v-if="enableLoader"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-container>
</template>
